var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import './index.less';
import GridContent from './GridContent';
import { Divider, PageHeader } from '../';
const renderPageHeader = (content, extraContent, prefixedClassName) => {
    if (!content && !extraContent) {
        return null;
    }
    return (<div className={`${prefixedClassName}-detail`}>
            <div className={`${prefixedClassName}-main`}>
                <div className={`${prefixedClassName}-row`}>
                    {content && <div className={`${prefixedClassName}-content`}>{content}</div>}
                    {extraContent && <div className={`${prefixedClassName}-extraContent`}>{extraContent}</div>}
                </div>
            </div>
        </div>);
};
const defaultPageHeaderRender = (props, value) => {
    const { title, showHeader = true, content, pageHeaderRender, extraContent, style, prefixCls } = props, restProps = __rest(props, ["title", "showHeader", "content", "pageHeaderRender", "extraContent", "style", "prefixCls"]);
    if (pageHeaderRender) {
        return pageHeaderRender(Object.assign(Object.assign({}, props), value));
    }
    let pageHeaderTitle = title;
    if (!title && title !== false) {
        pageHeaderTitle = value.title;
    }
    return (showHeader && (<PageHeader {...value} title={pageHeaderTitle} {...restProps} prefixCls={prefixCls}>
                {renderPageHeader(content, extraContent, value.prefixedClassName)}
            </PageHeader>));
};
const PageContainer = (props) => {
    const { children, style, ghost, divider = true, showHeader = true, prefixCls = 'oss-ui', gridContentClassName, gridContentStyle, } = props;
    const prefixedClassName = `${prefixCls}-page-container`;
    const className = classNames(prefixedClassName, props.className, {
        [`${prefixCls}-page-container-ghost`]: ghost,
        [`${prefixCls}-page-container-show-header-divider`]: showHeader && divider,
        [`${prefixCls}-page-container-show-header`]: !divider && showHeader,
    });
    return (<div style={style} className={className}>
            <div className={`${prefixedClassName}-wrap`}>
                {defaultPageHeaderRender(props, {
            prefixCls: undefined,
            prefixedClassName,
        })}
            </div>
            {showHeader && divider && <Divider style={{ margin: '0 0 8px 0' }}/>}
            <GridContent className={gridContentClassName} style={gridContentStyle}>
                {children ? children : null}
            </GridContent>
        </div>);
};
export default PageContainer;
